import styled from 'styled-components';
import React from 'react';

const Wrapper = styled.div<{ flex: string }>`
  background: #eef1f4;
  border-radius: 8px;
  padding: 14px 7px;
  display: flex;
  gap: 14px;
  flex-direction: column;
  flex: ${props => props.flex};
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000;
`;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

type Props = {
  flex?: string;
  label: string;
  children: React.ReactNode;
};

export const Level2Wrapper = ({ flex = '1 1 100%', label, children }: Props) => {
  return (
    <Wrapper flex={flex}>
      <Header>{label}</Header>
      <SectionContainer>{children}</SectionContainer>
    </Wrapper>
  );
};
